import portalCommunication from '@3plearning/mathletics-portal-communication-service';
import { isMobile } from 'react-device-detect';

import Resources from '../../helpers/resources';
import { navigateToModule, forceRender, getLocale } from '../../helpers/utils';
import { SHOW_CONFIRM_MODAL } from '../../containers/confirmation-modal/confirmation-modal-actions';

export const ACTIONED = 'ACTIONED';
export const PORTAL_SETUP = 'PORTAL_SETUP';
export const UPDATE_TITLE = 'UPDATE_TITLE';
export const FOOTER_BUTTONS_SETUP = 'FOOTER_BUTTONS_SETUP';
export const UPDATE_GROUP_LIST = 'UPDATE_GROUP_LIST';
export const REDO_UPDATE_GROUP_LIST = 'REDO_UPDATE_GROUP_LIST';
export const UPDATE_CLASS_LIST = 'UPDATE_CLASS_LIST';
export const UPDATE_STUDENT_LIST = 'UPDATE_STUDENT_LIST';
export const UPDATE_SELECTED_CLASS_GROUP = 'UPDATE_SELECTED_CLASS_GROUP';
export const CHECKBOX_SELECT = 'CHECKBOX_SELECT';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const NAVIGATE_MANAGE_STUDENTS = 'NAVIGATE_MANAGE_STUDENTS';
export const UNASSIGN_STUDENTS = 'UNASSIGN_STUDENTS';
export const UPDATE_QUERY_PARAMS = 'UPDATE_QUERY_PARAMS';
export const CLICK_ACTION_TYPE = 'CLICK_ACTION_TYPE';


export function actionCreator(payload) {
    return {
        type: ACTIONED,
        payload
    };
}

export const setupPortal = (showSpinning) => {
    // eslint-disable-next-line no-underscore-dangle
    if (window._env_ && window._env_.PortalModuleId) {
        // eslint-disable-next-line no-underscore-dangle
        const moduleId = window._env_.PortalModuleId;
        if (moduleId) {
            portalCommunication.informModuleChange(moduleId);
        }
    }
    portalCommunication.requestLoadingSpinner(showSpinning);
    return {
        type: PORTAL_SETUP
    };
};

export function updateTitle(title, subTitle) {
    return {
        type: UPDATE_TITLE,
        payload: {
            title,
            subTitle
        }
    };
}

export function setupButtons(leftButtons, rightButtons) {
    return {
        type: FOOTER_BUTTONS_SETUP,
        payload: {
            leftButtons,
            rightButtons
        }
    };
}

export const updateClassGroupId = (classId, groupId) => async (dispatch) => {
    if (groupId && groupId > 0) {
        portalCommunication.informClassGroupSelection(classId, groupId);
    } else {
        portalCommunication.informClassGroupSelection(classId);
    }
    dispatch({
        type: UPDATE_SELECTED_CLASS_GROUP,
        payload: {
            selectedClassId: classId,
            selectedGroupId: groupId
        }
    });
};

export const getAllData = (productId, classId, groupId) => async (dispatch) => {
    productId = productId || 1;
    classId = classId ? parseInt(classId, 10) : 0;
    groupId = groupId ? parseInt(groupId, 10) : 0;

    let getResults = await Resources.getTeacherClassMgmtData.get({ productId }).headers({ Locale: getLocale() });
    if (classId || groupId) {
        getResults = getResults.withParams({ classId, groupId });
    }

    const resource = await getResults.send();

    if (resource && resource.status > 199 && resource.status < 300) {
        const data = resource.data;
        const classList = data.classes;
        const groupList = data.classGroups;
        const studentList = data.classGroupStudents;
        const selectedClassId = data.classId || classId;
        const selectedGroupId = data.classGroupId || groupId;
        dispatch({
            type: UPDATE_CLASS_LIST,
            payload: {
                classList,
                selectedClassId,
                selectedGroupId
            }
        });

        dispatch({
            type: UPDATE_GROUP_LIST,
            payload: {
                groupList
            }
        });

        dispatch({
            type: UPDATE_STUDENT_LIST,
            payload: {
                studentList,
                studentSum: { checkboxSum: NaN, checkboxCount: 0, allSelected: false }
            }
        });

        updateClassGroupId(selectedClassId, selectedGroupId)(dispatch);
    } else if (resource.status === 400) {
        // to be handle later upon user story if provided.
    }
};

export const selectClass = (selectedClass, productId) => async (dispatch) => {
    productId = productId || 1;
    let classId = selectedClass ? selectedClass.classId : 0;
    classId = classId ? parseInt(classId, 10) : 0;

    const resource = await Resources.getTeacherClassMgmtClasses.get({ classId, productId })
        .headers({ Locale: getLocale() })
        .send();

    if (resource && resource.status > 199 && resource.status < 300) {
        const data = resource.data;
        const groupList = data.classGroups;
        const studentList = data.classGroupStudents;
        const selectedClassId = data.classId || classId;
        const selectedGroupId = data.classGroupId || 0;
        dispatch({
            type: UPDATE_GROUP_LIST,
            payload: {
                groupList
            }
        });

        dispatch({
            type: UPDATE_STUDENT_LIST,
            payload: {
                studentList,
                studentSum: { checkboxSum: NaN, checkboxCount: 0, allSelected: false }
            }
        });

        updateClassGroupId(selectedClassId, selectedGroupId)(dispatch);
    } else if (resource.status === 400) {
        // to be handle haere later or to delegate to portal upon user story if provided.
    }
};

export const selectGroup = (selectedClass, selectedGroup, productId) => async (dispatch) => {
    let classId = selectedClass.classId;
    let groupId = selectedGroup.groupId;
    productId = productId || 1;
    classId = classId ? parseInt(classId, 10) : 0;
    groupId = groupId ? parseInt(groupId, 10) : 0;

    const resource = await Resources.getTeacherClassMgmtGroups.get({ classId, groupId, productId })
        .headers({ Locale: getLocale() }).send();

    if (resource && resource.status > 199 && resource.status < 300) {
        const data = resource.data;

        const studentList = data.classGroupStudents;
        const selectedClassId = data.classId || classId;
        const selectedGroupId = data.classGroupId || groupId;

        dispatch({
            type: UPDATE_STUDENT_LIST,
            payload: {
                studentList,
                studentSum: { checkboxSum: NaN, checkboxCount: 0, allSelected: false }
            }
        });

        updateClassGroupId(selectedClassId, selectedGroupId)(dispatch);
    } else if (resource.status === 400) {
        // to be handle haere later or to delegate to portal upon user story if provided.
    }
};

export const unassignStudent = (studentUserProfileIdsToUnassign, productId, classroomId, classGroupId) =>
    async (dispatch) => {
        productId = productId || 1;
        classroomId = classroomId || 0;
        classGroupId = classGroupId || 0;
        const bePlural = ((studentUserProfileIdsToUnassign || []).length > 1);
        const classroomUnassignments = { productId, classroomId, studentUserProfileIdsToUnassign };
        const resource = await Resources.getTeacherClassMgmtUnassignStudent.patch()
            .withBody(classroomUnassignments)
            .headers({ Locale: getLocale() })
            .send();

        if (resource && resource.status > 199 && resource.status < 300) {
            const data = resource.data;

            const studentList = data.classGroupStudents;
            // const selectedClassId = data.classId; //  || classId;
            const selectedGroupId = data.classGroupId; // || groupId;

            dispatch({
                type: UNASSIGN_STUDENTS,
                payload: {
                    clickActionType: undefined
                }
            });

            if (classGroupId === selectedGroupId) {
                dispatch({
                    type: UPDATE_STUDENT_LIST,
                    payload: {
                        studentList,
                        studentSum: { checkboxSum: NaN, checkboxCount: 0, allSelected: false }
                    }
                });
            } else {
                // currently the response of getTeacherClassMgmtUnassignStudent is designed to be not required to
                // have information of current "selected GroupId" neither provide the selected group students, need
                // front end to readjustment for work out this.
                dispatch({
                    type: REDO_UPDATE_GROUP_LIST,
                    payload: {
                        redoUpdateGroup: true
                    }
                });
            }

            dispatch({
                type: SHOW_CONFIRM_MODAL,
                payload: {
                    displayInfo: {
                        type: 'display-success-unassign',
                        bePlural
                    }
                }
            });
        } else if (resource.status === 400) {
        // to be handle here later or to delegate to portal upon user story if provided.
        }
    };

export function checkboxSelect(checkboxInfo) {
    if (!checkboxInfo.checkAll) {
        const selected = !checkboxInfo.toWatch.selected;
        const countDelta = selected ? 1 : -1;
        checkboxInfo.toWatch.selected = !checkboxInfo.toWatch.selected;
        checkboxInfo.studentSum.checkboxCount += countDelta;

        if (checkboxInfo.studentSum.checkboxCount === checkboxInfo.studentSum.checkboxSum) {
            checkboxInfo.studentSum.allSelected = true;
        } else {
            checkboxInfo.studentSum.allSelected = false;
        }
        if (isMobile) {
            forceRender();
        }
    } else {
        const allSelected = !checkboxInfo.studentSum.allSelected;
        const allCount = allSelected ? checkboxInfo.studentSum.checkboxSum : 0;
        checkboxInfo.studentSum.checkboxCount = allCount;
        checkboxInfo.studentSum.allSelected = allSelected;

        const students = checkboxInfo.toWatch;
        students.forEach((student) => {
            student.selected = allSelected;
        });
    }

    return {
        type: CHECKBOX_SELECT,
        payload: {
            studentSum: checkboxInfo.studentSum
        }
    };
}

export const passwordUpdate = updateInfo => async (dispatch) => {
    let updateSuccess = false;

    const userProfileId = (updateInfo && updateInfo.student) ? updateInfo.student.userProfileId : 0;
    const userProfileIds = [userProfileId];
    const password = updateInfo ? updateInfo.newPassword : '';
    const studentPasswordUpdate = { userProfileIds, password }; // { userProfileIds: [0], password: undefined }; //

    const resource = await Resources.getTeacherClassMgmtUpdatePassword.patch()
        .withBody(studentPasswordUpdate)
        .headers({ Locale: getLocale() })
        .send();

    if (resource && resource.status > 199 && resource.status < 300) {
        const data = resource.data;
        updateSuccess = !!data; // make sure it will be true even it is none bool object
    } else {
        updateSuccess = false;
    }

    if (updateSuccess) {
        dispatch({
            type: UPDATE_PASSWORD,
            payload: {
                passwordRevertBack: false
            }
        });

        dispatch({
            type: REDO_UPDATE_GROUP_LIST,
            payload: {
                redoUpdateGroup: true
            }
        });
    } else {
        dispatch({
            type: UPDATE_PASSWORD,
            payload: {
                passwordRevertBack: true
            }
        });
    }
};

export const endPasswordRevertBack = () => ({
    type: UPDATE_PASSWORD,
    payload: {
        passwordRevertBack: false
    }
});

export const navigateBtnClick = (history, item, params) => (dispatch) => {
    navigateToModule(item.type, {
        ...params,
        sourceModule: 'whole-class'
    });
    dispatch({
        type: UPDATE_QUERY_PARAMS,
        payload: {
            sourceModule: 'whole-class'
        }
    });
    history.push(item.toUrl);
    dispatch({
        type: UPDATE_CLASS_LIST,
        payload: {
            classList: undefined
        }
    });
    dispatch({
        type: NAVIGATE_MANAGE_STUDENTS,
        payload: {
            item,
            params
        }
    });
};

export const downloadSignInCards = (StudentUserProfileIds, productId, ClassroomId, classGroupId, format) =>
    async () => {
        productId = Number(productId) || 1;
        ClassroomId = ClassroomId || 0;
        classGroupId = classGroupId || 0;
        const getStudentSignInCardsRequest = { StudentUserProfileIds,
            SignInCardPageSizeType: format,
            ClassroomId,
            GroupId: classGroupId };
        const resource = await (Resources.downloadStudentSignInCards)
            .post({ productId })
            .headers({ Locale: getLocale() })
            .withBody(getStudentSignInCardsRequest)
            .send();

        if (resource && resource.status > 199 && resource.status < 300) {
            const downloadUrl = `${resource.verb.url}/${resource.data}`;
            window.location.href = downloadUrl;
        }
    };

    // function mockData() {
    //     /* eslint-disable global-require */
    //     const data = require('./teacher-classes.json');
    //     /* eslint-enable global-require */
    //     return data;
    // }

export const resetClickActionType = () => ({
    type: CLICK_ACTION_TYPE
});



// WEBPACK FOOTER //
// ./containers/whole-class/whole-class-actions.js